import {useMemo} from 'react';
import {transformAccountDtoToPersonalAccount} from '~/contexts/UserAccount/account';
import {useAccountsApiClient} from '../useAccountsApiClient';
import {ApiClient} from '../../apiClient';
import {paths} from '../schema';

class AccountsRepository {
  constructor(private readonly client: ApiClient<paths>) {}

  public getPersonalAccount = async (email: string) => {
    const personalAccount = await this.client.get(`/accounts/personal`, {
      params: {
        query: {
          email
        }
      }
    });
    return transformAccountDtoToPersonalAccount(personalAccount);
  };
}

export const useAccountsRepository = () => {
  const client = useAccountsApiClient();

  return useMemo(() => new AccountsRepository(client), [client]);
};
